import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    const slider = this.el.querySelector('[data-slider]')
    const prevEl = this.el.querySelector('[data-slider-prev]')
    const nextEl = this.el.querySelector('[data-slider-next]')

    const swiper = new Swiper(slider, {
      modules: [Navigation],
      //   speed: 400,
      navigation: {
        nextEl,
        prevEl,
      },
      autoHeight: true,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
          autoHeight: false,
        },
        1280: {
          slidesPerView: 6,
        },
      },
    })
  }
}
